var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-container"},[_c('div',{ref:"myPie",staticClass:"pie"})])
}
var staticRenderFns = []

export { render, staticRenderFns }